package com.arenaproplay.admin.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.ui.utils.encodeQueryValue
import com.arenaproplay.admin.ui.utils.urlParam

/**
 * Legacy /social route — redirects to /moderation.
 *
 * Content has fully moved to ModerationPage (R7).
 * This stub keeps old bookmarks and external links working.
 *
 * URL param mapping:
 *   ?page=… → forwarded as ?page=…  (feed pagination)
 */
@Page("/social")
@Composable
fun SocialPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        val page = urlParam("page")?.ifBlank { null }
        val params = if (page != null) "?page=${encodeQueryValue(page)}" else ""
        ctx.router.navigateTo("${Routes.MODERATION}$params")
    }
}
